<app-transaction-activity-by-fa-ids
  [participatingFinancialAccountId]="participatingFinancialAccountId"
></app-transaction-activity-by-fa-ids>
